var module = angular.module('octopusApp.environments');

module.directive('machineList', function (octoUtil, octopusTagSets, octopusFeatures, targetStateMapper) {
    return {
        restrict: 'E',
        replace: false,
        scope: {
            machines: '=',
            show:'='
        },
        link: function(scope, element, attr) {

            var ensureMachineList = function (machines, element) {

                var renderMachineList = function() {
                    var html = [];

                    html.push('<ul class="octo-tiles">');
                    for (var i = 0; i < machines.length; i++) {
                        var machine = machines[i];

                        html.push('<li class="container-fluid machine clickable">');
                        html.push('<a href="#/machines/');
                        html.push(octoUtil.escapeHtml(machine.Id));
                        html.push('">');

                        html.push('<div class="row">');

                        renderStatus(html, machine);

                        html.push('<div class="machine-summary col-xs-9">');
                        html.push('<h5 title="' + octoUtil.escapeHtml(machine.Name)  + '">');
                        html.push(octoUtil.escapeHtml(machine.Name));
                        html.push('</h5>');

                        renderTags(html, machine);
                        renderRoles(html, machine);

                        html.push('</div>');
                        html.push('</div>');

                        html.push('</a>');
                        html.push('</li>');
                    }
                    html.push('</ul>');

                    return html.join('');
                };

                var update = function() {
                    var html = renderMachineList();
                    element.html(html);
                };

                update();
            };

            var render = function() {
                if (!scope.machines) {
                    return;
                }
                ensureMachineList(scope.machines, element);
            };

            var renderStatus = function(html, machine) {
                html.push('<div class="machine-status col-xs-3">');
                html.push('<img alt="');
                html.push(octoUtil.escapeHtml(machine.StatusSummary));
                html.push('" title="');
                html.push(octoUtil.escapeHtml(machine.StatusSummary));
                html.push('" src="');
                html.push(targetStateMapper.calculateTargetIcon(machine));
                html.push('" /></div>');
            };

            var renderRoles = function(html, machine) {
                if (machine.Roles.length <= 0) {
                    return;
                }

                html.push('<p>');
                for (var roleCount = 0; roleCount < machine.Roles.length; roleCount++)
                {
                    var role = machine.Roles[roleCount];
                    html.push('<span class="label truncate label-default">');
                    html.push(octoUtil.escapeHtml(role));
                    html.push('</span>');
                }
                html.push('</p>');
            };

            var renderTags = function(html, machine) {
                if (!octopusFeatures.isEnabled('IsMultiTenancyEnabled') || (!machine.selectedTags || machine.selectedTags.length <= 0)) {
                    return;
                }

                html.push('<div class="selected-tags-list">');

                for (var tagIndex = 0; tagIndex < machine.selectedTags.length; tagIndex++) {
                    var tag = machine.selectedTags[tagIndex];
                    html.push('    <div>');
                    html.push('        <i class="fa fa-square tag-swatch" style="color: ' + tag.Color + '" title="' + tag.Name + '"></i>');
                    html.push('    </div>');
                }
        
                html.push('</div>');
            };

            render();
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/environments/directives/machine_list.js
// module id = 430
// module chunks = 1